<template>
  <section class="comments">
    <div v-for="comment in comments"
         :key="comment.id"
    class="comment">
      <router-link :to="{name: 'User', params: { username: comment.User.username }}">
        <span class="comment-owner" :style="commentBackground(comment.User)">{{ comment.User.username }}</span>
      </router-link>
      <span>{{ comment.comment }}</span>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    comments: {
      required: true,
      type: Array
    },
    playerOneId: {
      required: true,
      type: Number
    },
    playerTwoId: {
      required: true,
      type: Number
    }
  },
  methods: {
    commentBackground (user) {
      let background = {backgroundImage: 'none'}
      if (user.id === this.playerOneId || user.id === this.playerTwoId) {
        background.backgroundImage = 'linear-gradient(141deg, #' +
          user.color1 +
          ', #' +
          user.color2 +
          ')'
        background.color = 'white'
      }
      return background
    }
  }
}
</script>

<style scoped>
  .comments {
    margin-top: 40px;
  }
  .comment {
    margin: 5px 0;
  }
  .comment-owner {
    padding: 3px;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MatchComments.vue